import React from 'react';
import { Play, FastForward, SkipForward } from 'lucide-react';
import { useTranslation } from '../../i18n';

export function DayControls({ hasPending, fastForwarding, onNextDay, onFastForward }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex gap-2" data-testid="day-controls">
        <button
          onClick={onNextDay}
          disabled={hasPending || fastForwarding}
          className={`flex-1 py-3.5 rounded-md font-bold text-sm transition-all ${
            hasPending || fastForwarding
              ? 'bg-ink-700 text-slate-500 cursor-not-allowed border border-ink-600'
              : 'bg-money/15 hover:bg-money/25 text-money border border-money/40 hover:shadow-glow-money'
          }`}
          data-testid="next-day-button"
        >
          <div className="flex items-center justify-center gap-2 font-mono uppercase tracking-wider text-[13px]">
            <Play className="w-4 h-4" />
            {hasPending ? t('resolve_events') : t('next_day')}
          </div>
        </button>

        <button
          onClick={() => onFastForward(5)}
          disabled={hasPending || fastForwarding}
          className={`px-4 py-3.5 rounded-md transition-all border ${
            hasPending || fastForwarding
              ? 'bg-ink-700 text-slate-500 cursor-not-allowed border-ink-600'
              : 'bg-ink-700 hover:bg-ink-600 text-slate-200 border-ink-600 hover:border-accent'
          }`}
          title={t('advance_5days')}
          data-testid="fast-forward-5-btn"
        >
          <div className="flex items-center gap-1.5 font-mono uppercase tracking-wider text-[11px]">
            <FastForward className="w-3.5 h-3.5" /> +5j
          </div>
        </button>

        <button
          onClick={() => onFastForward(7)}
          disabled={hasPending || fastForwarding}
          className={`px-4 py-3.5 rounded-md transition-all border ${
            hasPending || fastForwarding
              ? 'bg-ink-700 text-slate-500 cursor-not-allowed border-ink-600'
              : 'bg-ink-700 hover:bg-ink-600 text-slate-200 border-ink-600 hover:border-accent'
          }`}
          title={t('advance_week')}
          data-testid="fast-forward-7-btn"
        >
          <div className="flex items-center gap-1.5 font-mono uppercase tracking-wider text-[11px]">
            <SkipForward className="w-3.5 h-3.5" /> +1sem
          </div>
        </button>
      </div>

      {fastForwarding && (
        <div className="surface-elevated px-4 py-2 text-center border-accent/40">
          <p className="text-xs text-accent font-mono uppercase tracking-wider animate-pulse">{t('fast_forward')}</p>
        </div>
      )}
    </>
  );
}
